import secureLocalStorage from "react-secure-storage";
import { formatNumber } from "@telerik/kendo-intl";
import * as React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
export default class ReductionProbability extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temp:this.props.dataItem[this.props.field]
    };
  }
  componentDidMount = () => {
    if(this.props.dataItem.inEdit&&document.getElementById("mitigationreductionprobablityId")){
        document.getElementById("mitigationreductionprobablityId").focus();
    }
  };
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
  };
  handleEditCell = () => {
    if(this.props.dataItem.isOpen==="Open" || this.props.dataItem.isOpen===true){
    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.userId;
 const riskOwnerId=this.props.riskDetails?this.props.riskDetails.userId:null;

    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <NumericTextBox
            defaultValue={dataValue}
            onChange={(e) => this.handleChange(e)}
            onBlur={this.handleBlur}
            min={0}
            max={100}
            id="mitigationreductionprobablityId"
          />
        </td>
      );
    } else {
      if((loginUserId===ownerId||loginUserId===riskOwnerId)&&this.props.dataItem.isOpen===true){
          return (
            <td onClick={this.handleEditCell}>{formatNumber(dataValue, "##,#")}</td>
          )
      }else{
        return (
          this.props.dataItem.role == "View Only" ||this.props.dataItem.role == "Standard User"||this.props.dataItem.isOpen==false ? (
                <td >{formatNumber(dataValue, "##,#")}</td>
              ):(
                <td onClick={this.handleEditCell}>{formatNumber(dataValue, "##,#")}</td>
              )
         
        );
      }
     
    }
  }
}
